import createReactClass from 'create-react-class';
import React from 'react';
import ReactDOM from 'react-dom';
import NumericMixin from '../../../../mixins/numeric-mixin';
import EnhancedButton from '../../outline-button';

import './style.css';

export default createReactClass({
  mixins: [NumericMixin],

  getInitialState: function () {
    return { value: '' };
  },

  componentWillUnmount() {
    var intVal = Math.floor(this.state.value);
    if (intVal < this.props.min) {
      this.update(this.props.min);
    }
  },

  getDefaultProps: function () {
    return { decimals: 2 };
  },

  onClick: function (v, e) {
    e.preventDefault();
    e.stopPropagation();
    this.update(this.state.value == 0 ? v : this.state.value + v);
  },

  close: function (e) {
    this.props.close();
  },

  onKeyDown: function (e) {
    var key = e.which || e.keyCode;
    var val = this.state.value;

    if (key == 8) {
      e.preventDefault();
      val = val.length < 1 ? '' : val.substring(0, val.length - 1);
      this.update(val);
    }
    if (key == 13) {
      this.close(e);
    }
  },

  onKeyPress: function (e, v) {
    switch (e.key.toLowerCase()) {
      case 'c':
        this.onClear();
        break;
      case '-':
        this.onNegate();
        break;
      default:
        this.update(this.state.value + e.key);
    }

    this.focus(e.key);
  },

  onClear: function () {
    this.update('');
  },

  update: function (value) {
    const { max, min } = this.props;
    const v = Number(value);
    var dp = this.props.decimals;
    var pattern = dp > 0 ? /^\-?\d*\.?\d*$/ : /^\-?\d*$/;
    if (!value.match(pattern)) return;
    if (max != null && v > max) {
      value = max.toString();
    }
    if (min != null && v < min) {
      value = min.toString();
    }
    this.setState({ value: value });
    this.props.onChange(value);
  },

  onNegate: function () {
    var val = this.state.value;
    val = val.match(/^-/) ? val.substring(1) : '-' + val;
    this.update(val);
  },

  focus: function (val) {
    var key = this.refs['key' + val.toLowerCase()];
    if (!!!key) return;
    ReactDOM.findDOMNode(key).focus();
  },

  render: function () {
    var style = { margin: 8 };
    let decimal = null;
    let negate = null;
    if (this.props.decimals && parseInt(this.props.decimals) > 0) {
      decimal = (
        <EnhancedButton
          skipDebounce={true}
          tabIndex={-1}
          onClick={this.onClick.bind(this, '.')}
          style={style}
        >
          .
        </EnhancedButton>
      );
    }

    if (this.props.min && parseInt(this.props.min < 0)) {
      negate = (
        <EnhancedButton
          skipDebounce={true}
          tabIndex={-1}
          onClick={this.onNegateIconButton}
          style={style}
        >
          +/-
        </EnhancedButton>
      );
    }

    return (
      <div
        tabIndex={-1}
        style={this.props.style}
        className="bz-numpad"
        onKeyPress={this.onKeyPress}
        onKeyDown={this.onKeyDown}
      >
        <table>
          <tbody>
            <tr>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '1')}
                  onTouchStart={this.onClick.bind(this, '1')}
                  style={style}
                >
                  1
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '2')}
                  style={style}
                >
                  2
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '3')}
                  style={style}
                >
                  3
                </EnhancedButton>
              </td>
            </tr>
            <tr>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '4')}
                  style={style}
                >
                  4
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '5')}
                  style={style}
                >
                  5
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '6')}
                  style={style}
                >
                  6
                </EnhancedButton>
              </td>
            </tr>
            <tr>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '7')}
                  style={style}
                >
                  7
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '8')}
                  style={style}
                >
                  8
                </EnhancedButton>
              </td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '9')}
                  style={style}
                >
                  9
                </EnhancedButton>
              </td>
            </tr>
            <tr>
              <td>{decimal}</td>
              <td>
                <EnhancedButton
                  skipDebounce={true}
                  tabIndex={-1}
                  onClick={this.onClick.bind(this, '0')}
                  style={style}
                >
                  0
                </EnhancedButton>
              </td>
              <td>{negate}</td>
            </tr>
            <tr>
              <td colSpan={3}>
                <EnhancedButton
                  skipDebounce={true}
                  style={{ width: '100%' }}
                  tabIndex={-1}
                  onClick={this.onClear}
                >
                  Clear
                </EnhancedButton>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
});

// <tr>
//   <td colSpan={3} >
//     <EnhancedButton skipDebounce={true} style={{marginTop:4, width:'100%'}} tabIndex={-1} onTouchStart={this.close} onMouseDown={this.close}>Close</EnhancedButton>
//   </td>
// </tr>
